// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3WCGl","inner":"Footer_inner__1dBBM"};